import { Component, OnInit } from '@angular/core';
import { ModalComponent } from '@clooper/modals';

@Component({
  selector: 'app-free-trial-benefits',
  templateUrl: './free-trial-benefits.component.html',
  styleUrls: ['./free-trial-benefits.component.scss']
})
export class FreeTrialBenefitsComponent extends ModalComponent implements OnInit {

  constructor() { 
    super()
  }

  ngOnInit(): void {}

}
